import React from 'react';
import { QuizQuestion, QuizCategory } from '../types/quiz';

interface ScoreBreakdownProps {
  answers: boolean[];
  questions?: QuizQuestion[];
  categories?: QuizCategory[];
}

const defaultCategories: QuizCategory[] = [
  { name: '생활습관', color: '#4CAF50', indices: [0, 1] },
  { name: '식습관', color: '#FF9800', indices: [4, 8, 12, 13, 14] },
  { name: '유해습관', color: '#f44336', indices: [2, 3] },
  { name: '건강관리', color: '#2196F3', indices: [6, 7, 11] },
  { name: '가족력', color: '#9C27B0', indices: [9, 10] },
  { name: '정신건강', color: '#00BCD4', indices: [5, 15] },
];

const ScoreBreakdown: React.FC<ScoreBreakdownProps> = ({ answers, questions, categories }) => {
  const cats = categories || defaultCategories;

  const getCategoryScore = (cat: QuizCategory) => {
    let earned = 0;
    const questionList = questions;

    cat.indices.forEach((idx) => {
      if (idx < answers.length && questionList && idx < questionList.length) {
        const q = questionList[idx];
        earned += answers[idx] ? q.yesScore : q.noScore;
      }
    });

    const minPossible = cat.indices.reduce((sum, idx) => {
      if (!questionList || idx >= questionList.length) return sum;
      const q = questionList[idx];
      return sum + Math.min(q.yesScore, q.noScore);
    }, 0);
    const maxPossible = cat.indices.reduce((sum, idx) => {
      if (!questionList || idx >= questionList.length) return sum;
      const q = questionList[idx];
      return sum + Math.max(q.yesScore, q.noScore);
    }, 0);

    const range = maxPossible - minPossible;
    if (range === 0) return 0;
    return Math.round(((earned - minPossible) / range) * 100);
  };

  return (
    <div style={{ width: '100%', maxWidth: '500px', margin: '20px 0' }}>
      <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '16px' }}>
        📊 카테고리별 건강 점수
      </p>
      {cats.map((cat) => {
        const percentage = getCategoryScore(cat);
        return (
          <div key={cat.name} style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
              <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>{cat.name}</span>
              <span style={{ fontSize: '13px', color: '#666' }}>{percentage}%</span>
            </div>
            <div style={{ width: '100%', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '10px', overflow: 'hidden' }}>
              <div style={{
                width: `${percentage}%`,
                height: '100%',
                backgroundColor: cat.color,
                borderRadius: '10px',
                transition: 'width 1s ease-out',
              }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScoreBreakdown;
